import './App.css'
import TrainingScores from './components/TrainingScores'
import { useState, useEffect } from 'react';

function App() {
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchScores = async () => {
      try {
        // 使用相对路径
        const response = await fetch('/api/training-scores');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setScores(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching training scores:', error);
        setError(error.message);
        setLoading(false);
      }
    };
    
    fetchScores();
  }, []);

  return (
    <div style={{ 
      backgroundColor: '#1a1a2e',
      minHeight: '100vh',
      color: '#ffffff'
    }}>
      <TrainingScores scores={scores} loading={loading} error={error} />
    </div>
  )
}

export default App